import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import TranslationText from '@Components/Utilities/TranslationText';
import ErrorNavigationButtons from '@Components/Error/ErrorNavigationButtons';
import SiteMapLinks from '@Components/Shared/SiteMapLinks';

const NotFoundView = (props) => {
    return (
        <div className='error-content-container not-found'>
            {props.ShowNavigationLinks && <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />}                                    
            <div className='inner-wrap'>
                <div className='column12 pad-t left large-12 medium-11 small-12'>
                    <h1 className='pagename border-bottom'><TranslationText tKey='sandhills.tradepubwebsite.mvc.canwehelpyou' /></h1>
                    <div dangerouslySetInnerHTML={{ __html: props.NotFoundText }} />
                </div>
                {props.ShowNavigationLinks && <ErrorNavigationButtons {...props} />}                    
                {!props.ShowSiteMapLinks && <SiteMapLinks {...props.SiteMap} /> }
            </div>
        </div>
    );
};

export default NotFoundView;
global.NotFoundView = NotFoundView;